<template>
  <modalDialog class="modal--personalized" @close="close">
    <p slot="header">{{ $t("xpo.confirmDataDelivery") }}</p>
    <div slot="form" class="form">
      <div class="form__row" v-for="field in form.fields" :key="field.id">
        <div class="form__title required">
          {{ $t(field.text) }}
        </div>
        <div class="form__field">
          <input
            :id="field.id"
            :type="field.type"
            v-model="field.value"
            class="form-input"
            :maxlength="field.length"
          />
          <small class="red-text"></small>
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="form__legalData" id="legalDataContainer">
        <input type="checkbox" id="legalCheckbox" v-model="acceptLegalData" />
        <label for="legalCheckbox">{{
          $t("xpo.legalPersonalData.confirm")
        }}</label>
        <label @click="showPersonalData" class="legalData__link">{{
          $t("xpo.legalPersonalData.confirm2")
        }}</label>
      </div>
      <button cancel class="btn btn--white modal__btn" @click="back">
        {{ $t("xpo.button.back") }}
      </button>
      <button save class="btn btn--red modal__btn" @click="save">
        {{ $t("xpo.button.purchase") }}
      </button>
      <button cancel class="btn btn--white modal__btn" @click="close">
        {{ $t("global.button.cancel") }}
      </button>
      <form name="redsysForm" :action="redsysUrl" method="POST">
        <input
          type="hidden"
          name="Ds_SignatureVersion"
          :value="signatureVersion"
        />
        <input
          type="hidden"
          name="Ds_MerchantParameters"
          :value="merchantParameters"
        />
        <input type="hidden" name="Ds_Signature" :value="signature" />
      </form>
    </div>
  </modalDialog>
</template>

<style src="./css/common.css"></style>

<script>
import modalDialog from "@/components/ModalDialogFrame.vue";
import http from "@/http-commons";

const CONTEXT = "/public/purchaseData";

export default {
  components: {
    modalDialog
  },
  name: "DialogCollectDataConfirmService",
  props: {
    uuid: {
      type: String,
      required: false
    },
    additionalServicesSelected: {
      required: true
    }
  },
  data: () => ({
    token: null,
    consigneePostalCode: null,
    country: null,
    acceptLegalData: false,
    form: {
      fields: [
        {
          value: "",
          id: "form-name",
          length: 60,
          text: "change.dialog.name",
          valid: null
        },
        {
          value: "",
          id: "form-address",
          length: 60,
          text: "change.dialog.address",
          valid: null
        },
        {
          value: "",
          id: "form-postal-code",
          length: 12,
          text: "postalCode",
          valid: null
        },
        {
          value: "",
          id: "form-city",
          length: 60,
          text: "city",
          valid: null
        },
        {
          value: "",
          id: "form-phone",
          length: 15,
          text: "phoneMobile",
          valid: null
        },
        {
          value: "",
          id: "form-mail",
          length: 60,
          text: "mail",
          type: "email",
          valid: null
        },
        {
          value: "",
          id: "form-nif",
          length: 24,
          text: "identityDocument",
          valid: null
        }
      ]
    },
    redsysUrl: process.env.VUE_APP_REDSYS_PAYMENT,
    signatureVersion: null,
    signature: null,
    merchantParameters: null
  }),
  methods: {
    loadForm(expedition) {
      this.resetForm();
      this.token = expedition.token;
      this.consigneePostalCode = expedition.consigneePostalCode;
      this.country = expedition.consigneeCountry;
      this.form.fields.find(element => element.id == "form-name").value =
        expedition.consigneeName;
      this.form.fields.find(element => element.id == "form-address").value =
        expedition.consigneeAddress;
      this.form.fields.find(element => element.id == "form-postal-code").value =
        expedition.consigneePostalCode;
      this.form.fields.find(element => element.id == "form-city").value =
        expedition.consigneeCity;
      this.form.fields.find(element => element.id == "form-phone").value =
        expedition.consigneeTelephone;
      this.form.fields.find(element => element.id == "form-mail").value =
        expedition.consigneeEmail;
    },
    validateStandardField(fieldIdName, minLength, maxLength) {
      let valid = false;
      const fieldName = document.getElementById(fieldIdName);
      const nameValue = fieldName.value.trim();
      if (!this.isRequired(nameValue)) {
        this.showError(fieldIdName, this.$t("global.form.validation.required"));
      } else if (!this.isBetween(nameValue.length, minLength, maxLength)) {
        this.showError(
          fieldIdName,
          this.$t("global.form.validation.between", {
            min: minLength,
            max: maxLength
          })
        );
      } else {
        this.showSuccess(fieldIdName);
        valid = true;
      }
      return valid;
    },
    validateMailField(fieldIdName, minLength, maxLength) {
      let valid = this.validateStandardField(fieldIdName, minLength, maxLength);
      if (valid) {
        const fieldName = document.getElementById(fieldIdName);
        const nameValue = fieldName.value.trim();
        if (!this.isEmailValid(nameValue)) {
          this.showError(fieldIdName, this.$t("global.form.validation.email"));
        } else {
          this.showSuccess(fieldIdName);
          valid = true;
        }
      }
      return valid;
    },
    resetForm() {
      for (const field in this.form.fields) {
        this.form.fields[field].value = "";
        this.form.fields[field].valid = null;
        this.resetFieldStatus(this.form.fields[field].id);
      }

      const legalDataContainer = document.getElementById("legalDataContainer");
      legalDataContainer.classList.remove("error");
    },
    confirmatePurchase(response) {
      let self = this;
      http
        .post(CONTEXT + "/redsysCallbackFree", {
          amount: response.data.amount,
          ds_SignatureVersion: response.data.ds_SignatureVersion,
          ds_MerchantParameters: response.data.ds_MerchantParameters,
          ds_Signature: response.data.ds_Signature,
          orderNumber: response.data.orderNumber
        })
        .then(e => {
          console.log("Ok: ", e);
          self.$parent.freePurchase = true;
          self.close();
        })
        .catch(e => {
          console.log("Error: ", e);
          self.openMessageDialog();
        });
    },
    save() {
      if (this.acceptLegalData) {
        if (this.validateForm()) {
          let self = this;
          http
            .post(
              CONTEXT +
                "/create/" +
                self.token +
                "/" +
                self.consigneePostalCode,
              self.generatePostObject(self.additionalServicesSelected)
            )
            .then(response => {
              self.signatureVersion = response.data.ds_SignatureVersion;
              self.signature = response.data.ds_Signature;
              self.merchantParameters = response.data.ds_MerchantParameters;
              self.totalAmount = response.data.amount;
              if (self.totalAmount > 0) {
                self.$nextTick(() => {
                  document.forms["redsysForm"].submit();
                });
              } else {
                this.confirmatePurchase(response);
              }
            })
            .catch(e => {
              console.log("Error: ", e);
            });
        }
        <style src="./css/modalDialogFrame.css"></style>;
      } else {
        const legalDataContainer = document.getElementById(
          "legalDataContainer"
        );
        legalDataContainer.classList.add("error");
      }
    },
    generatePostObject(servicesList) {
      let cleanServicesList = [...servicesList];
      cleanServicesList.forEach(function(service) {
        service.incompatibleProducts = undefined;
        service.requiredProducts = undefined;
        service.dependentProducts = undefined;
        service.reverseDependentProducts = undefined;
      });

      let purschaseData = {
        buyersName: this.form.fields.find(element => element.id == "form-name")
          .value,
        buyersAddress: this.form.fields.find(
          element => element.id == "form-address"
        ).value,
        buyersPostalCode: this.form.fields.find(
          element => element.id == "form-postal-code"
        ).value,
        buyersCountry: this.country,
        buyersCity: this.form.fields.find(element => element.id == "form-city")
          .value,
        buyersTelephone: this.form.fields.find(
          element => element.id == "form-phone"
        ).value,
        buyersMail: this.form.fields.find(element => element.id == "form-mail")
          .value,
        buyersIdentity: this.form.fields.find(
          element => element.id == "form-nif"
        ).value,
        additionalServices: cleanServicesList,
        additionalParamsUrl: []
      };
      if (this.uuid !== undefined) {
        purschaseData.additionalParamsUrl.push("uuid=" + this.uuid);
      }
      return purschaseData;
    },
    validateForm() {
      for (const field in this.form.fields) {
        let valid = false;
        switch (this.form.fields[field].type) {
          case "email":
            valid = this.validateMailField(
              this.form.fields[field].id,
              1,
              this.form.fields[field].length
            );
            break;
          default:
            valid = this.validateStandardField(
              this.form.fields[field].id,
              1,
              this.form.fields[field].length
            );
            break;
        }
        this.form.fields[field].valid = valid;
      }
      return (
        this.form.fields.find(element => element.valid === false) === undefined
      );
    },
    showSuccess(fieldIdName) {
      const fieldName = document.getElementById(fieldIdName);
      const fieldNameContainer = fieldName.parentElement;

      fieldNameContainer.classList.remove("error");
      fieldNameContainer.classList.add("success");

      // hide the error message
      const error = fieldNameContainer.querySelector("small");
      error.textContent = "";
    },
    showError(fieldIdName, message) {
      const fieldName = document.getElementById(fieldIdName);
      const fieldNameContainer = fieldName.parentElement;

      fieldNameContainer.classList.remove("success");
      fieldNameContainer.classList.add("error");

      const error = fieldNameContainer.querySelector("small");
      error.textContent = message;
    },
    resetFieldStatus(fieldIdName) {
      const fieldName = document.getElementById(fieldIdName);
      const fieldNameContainer = fieldName.parentElement;

      fieldNameContainer.classList.remove("error");
      fieldNameContainer.classList.remove("success");

      // hide the error message
      const error = fieldNameContainer.querySelector("small");
      error.textContent = "";
    },
    back() {
      this.$emit("back");
    },
    showPersonalData() {
      this.$emit("showPersonalData");
    },
    close() {
      this.$emit("close");
    },
    isEmailValid(email) {
      const re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      return re.test(email);
    },
    isRequired(value) {
      return value === "" ? false : true;
    },
    isBetween(length, min, max) {
      return length < min || length > max ? false : true;
    }
  }
};
</script>

<style scoped>
.form {
  max-height: 45vh;
  overflow-y: auto;
}
.form__legalData {
  font-size: 0.9rem;
  margin-bottom: 5px;
}
.legalData__link {
  text-decoration: underline;
  cursor: pointer;
}
.form__legalData.error > label {
  color: #cc0000;
  font-weight: bold;
}
</style>
